import Vue from "vue";
import router from "../../router";
import { setCommon, setPage } from "@/utils/request";
type FunctionOrNull = Function | null;

// 请求方法 --- 请求体----请求参数
class InnerRequest {
  requestMethod: any;
  requestBodyFinally: any;
  isTransfer: boolean;
  constructor(requestMethod: any, method: any, requestBody: any, data: any, isTransfer = true) {
    this.requestMethod = requestMethod[method].bind(requestMethod);
    this.isTransfer = isTransfer;
    this.requestBodyFinally = requestBody;
    let dataProcess: any = data;
    if('pageIndex' in dataProcess || 'pageSize' in dataProcess) {
      this.requestBodyFinally['setPagein'](setPage(dataProcess.pageIndex, dataProcess.pageSize, dataProcess.sort || '', dataProcess.rank || ''));
      delete dataProcess.pageIndex;
      delete dataProcess.pageSize;
      delete dataProcess.sort;
      delete dataProcess.rank;
    }
    if('setCommonin' in dataProcess) {
      delete dataProcess.setCommonin
    }
    for(let key in dataProcess) {
      this.requestBodyFinally[key](dataProcess[key])
    }
    this.requestBodyFinally['setCommonin'](setCommon());
  }
  getRequest() {
    return new Promise((resolve, reject) => {
      this.requestMethod(this.requestBodyFinally, {}, (err: any, response: any) => {
        response && resolve(this.isTransfer ? response.toObject() : response);
        err && reject(err);
      })
    })
      .then((response: any) => {
        response.loading = false;
        this.handleResponse(response, null);
        return Promise.resolve(response);
      })
      .catch((err: any) => {
        if(  err.code && err.code == 16) {
          router.push("./login")
        } else {
          this.errorAlert(err.message);
          return Promise.reject(err)
        }
      });
  }
  handleResponse(res: any, fuc: FunctionOrNull) {
    let _status = res.commonout ? res.commonout : res;
    switch (_status.code) {
      case 0:
        res.right = true;
        break;
      case 102:
        res.right = true;
        break;
      case 100100:
        this.routerNavigate("./login");
        break;
      case 100101:
        this.routerNavigate("./login");
        break;
      default:
        res.right = false;
        this.errorAlert(_status.errmsg ? _status.errmsg : _status.message);
    }
    return fuc ? fuc(res) : res;
  }

  errorAlert(message: string) {
    Vue.prototype.$message({
      message: message,
      type: "error"
    });
  }
  routerNavigate(router: string) {
    Vue.prototype.$selfRouter.push(router);
  }
}

export {
  InnerRequest
}
